import React, { useEffect, useState } from "react";
import { BiLike, BiDislike } from "react-icons/bi";
import { FaRegCircleUser } from "react-icons/fa6";

import { useSearchParams } from "react-router-dom";
import { API_KEY, YOUTUBE_COMMENTS_THREAD } from "../utils/constants";

const CommentsContainer = () => {
  const [comments, setComments] = useState();

  const getCommentsThread = async () => {
    const data = await fetch(
      YOUTUBE_COMMENTS_THREAD + searchParams.get("v") + "&key=" + API_KEY
    );
    const json = await data.json();
    console.log("json comments:>> ", json.items);
    setComments(json.items);
  };
  useEffect(() => {
    getCommentsThread();
  }, []);

  let [searchParams] = useSearchParams();
  console.log("searchParams pk", searchParams.get("v"));
  return (
    <div className="  md:w-[888px]">
      <h1 className="text-2xl font-bold ">Comments:</h1>
      {comments &&
        comments.map((c) => (
          <div className=" flex  items-start my-5" key={c.id}>
            {c.snippet.topLevelComment.snippet.authorProfileImageUrl && ( // Check if profile image URL is available
              <img
                className="rounded-full mr-4"
                alt="ChannnelImage"
                src={c.snippet.topLevelComment.snippet.authorProfileImageUrl}
              />
            )}

            <div>
              <div className="font-bold text-sm">
                {c.snippet.topLevelComment.snippet.authorDisplayName}
              </div>
              <div className="text-sm">
                {" "}
                {c.snippet.topLevelComment.snippet.textOriginal}
              </div>
              <div className="m-2 flex items-center">
                {" "}
                <BiLike className="mr-2" size={20} />
                {c.snippet.topLevelComment.snippet.likeCount}{" "}
                <BiDislike className="ml-5" size={20} />
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};

export default CommentsContainer;
